'use strict';

var helper = require('../../helper');
var loaderInstance = require('../../loaderHelper');
var venmoButton = require('../components/venmoButton');
var venmoHelper = require('../helpers/venmoHelper');
var venmoErrorHandler = require('../errorhandler/venmoErrorHandler');

var $venmoButton = document.querySelector('.js_braintree_accountVenmoButton');
var venmoLoader;

/**
 * Makes Venmo account as default one
 * @param {Event} e event to identify target element
 */
function makeDefaultVenmo(e) {
    var target = e.target;
    var url = target.getAttribute('data-make-default-url');
    var id = target.getAttribute('data-id');
    var paymentMethodID = document.querySelector('.venmo-accounts').getAttribute('data-payment-method-id');
    var $loaderContainter = document.querySelector('#' + target.getAttribute('data-loader'));
    var loader = loaderInstance($loaderContainter);

    loader.show();

    helper.setDefaultProperty({
        url: url,
        id: id,
        paymentMethodID: paymentMethodID,
        loader: loader
    });
}

/**
 * Creates Venmo form data on account page
 * @param {string} nonce Braintree Venmo nonce
 * @returns {Object} object with Venmo form data
 */
function createVenmoAccountFormData(nonce) {
    var venmoAccountFormFields = $venmoButton.getAttribute('data-venmo-account-form-fields');
    var csrfToken = document.querySelector('.js_braintree_accountVenmoButton_wrapper #csrf_token');

    var venmoAccountFormData = helper.createPaymentFormData(venmoAccountFormFields, {
        nonce: nonce
    });

    venmoAccountFormData.append(csrfToken.name, csrfToken.value);

    return venmoAccountFormData;
}

/**
 * Stores new Venmo account
 * @param {Object} data tokenized payload data with Venmo nonce
 * @returns {ajax} call to Braintree-AccountAddVenmoHandle endpoint
 */
function storeNewVenmoAccount(data) {
    var venmoAddAccountHandlerUrl = $venmoButton.getAttribute('data-venmo-add-account-handler');
    var venmoAccountFormData = createVenmoAccountFormData(data.nonce);

    venmoLoader.show();

    return $.ajax({
        type: 'POST',
        url: venmoAddAccountHandlerUrl,
        data: venmoAccountFormData,
        contentType: false,
        processData: false
    })
        .then((paymentData) => {
            venmoHelper.hideVenmoAccountBtn();
            venmoLoader.hide();

            $.get(paymentData.renderAccountsUrl)
                .then((tplData => {
                    document.querySelector('.venmo-accounts').innerHTML = tplData;
                    document.querySelectorAll('.venmo-accounts .remove-bt-payment').forEach(function (el) {
                        el.addEventListener('click', helper.removeBtPayment);
                    });
                }));
        })
        .fail(({ responseJSON }) => {
            venmoLoader.hide();

            venmoErrorHandler.showVenmoError(responseJSON.error);
        });
}

/**
 * Inits Venmo functionality
 * @param {Object} btVenmoModel Braintree Venmo model
 */
function init(btVenmoModel) {
    var isVenmoButtonEnabledOnAccountPage = Boolean(document.querySelector('.js_braintree_accountVenmoButton'));
    var $braintreeVenmoLoader = document.querySelector('#braintreeVenmoAccLoader');

    venmoLoader = loaderInstance($braintreeVenmoLoader);

    if (isVenmoButtonEnabledOnAccountPage) {
        // "Make default" button functionality initiation
        $('.venmo-accounts').on('click', '.braintree-make-default-card', makeDefaultVenmo);

        // "Remove" button functionality initiation
        $('.venmo-accounts').on('click', '.remove-bt-payment', helper.removeBtPayment);

        // "Add New" Venmo button functionality initiation
        $('.add-venmo-account').click(function () {
            venmoHelper.showVenmoAccountBtn();

            if (!window.venmoAccountButtonInited) {
                window.venmoAccountButtonInited = true;

                venmoButton.init(btVenmoModel, $venmoButton);
            }
        });

        return;
    }

    var isVenmoAccountBlockExists = Boolean(document.querySelector('.venmo-accounts'));

    if (isVenmoAccountBlockExists) {
        // "Make default" button functionality initiation
        $('.venmo-accounts').on('click', '.braintree-make-default-card', makeDefaultVenmo);

        // "Remove" button functionality initiation
        $('.venmo-accounts').on('click', '.remove-bt-payment', helper.removeBtPayment);
    }
}

module.exports = {
    init,
    storeNewVenmoAccount
};
